@app.directive 'matrixItemIconForm', (AnalyticsService) ->
  restrict: 'E'
  scope: {}
  controller: ->
    @setItem = (selectedItem, currentItem)->
      angular.forEach currentItem.content, (value, key) ->
        if selectedItem.hasOwnProperty(key)
          currentItem.content[key] = selectedItem[key]
    this
  controllerAs: 'matrixItemIconForm'
  templateUrl: "/assets/templates/components/matrix/matrixItem/matrixItemIcon/matrixItemIconForm.html"
  bindToController: {
    content: '='
    descriptionCharLimit: '='
    showLikes: '='
    loadImageOnEnterViewport: '='
    source: '@'
  }
